export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_13.e728c56f.jpg";